import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bf3b48f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tip"
}
const _hoisted_2 = ["innerHTML"]

import { computed } from 'vue';
import { showTextSequence } from '@/utils/tool';

export default /*#__PURE__*/_defineComponent({
  props: ['width', 'value', 'isSeq'],
  setup(__props) {

const props = __props

const isShow = computed(() => {
  if(props.width) {
    if(props.width > String(props.value).length * 14) {
      return false
    }
    return true
  }
  return false
})

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (!_unref(isShow))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.value), 1))
    : (_openBlock(), _createBlock(_component_a_tooltip, { key: 1 }, {
        title: _withCtx(() => [
          _createElementVNode("div", {
            innerHTML: __props.isSeq ? _unref(showTextSequence)(__props.value) : __props.value
          }, null, 8, _hoisted_2)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "tip",
            style: _normalizeStyle({'width': __props.width ? __props.width + 'px' : '100%'})
          }, _toDisplayString(__props.value), 5)
        ]),
        _: 1
      }))
}
}

})